import { schema } from 'normalizr';

const optionSchema = new schema.Entity('options');

const questionSchema = new schema.Entity('questions', {
  options: [optionSchema]
});

export const encounterNoteSectionSchema = new schema.Entity(
  'encounterNoteSections',
  {
    questions: [questionSchema]
  },
  { idAttribute: 'sectionId' }
);
